import React from 'react';
import Header from '../components/layout/header';

import Footerr from '../components/layout/footer';
import { useState } from 'react';
import Preloader from '../components/common/preloader';
import Sec1booking from '../sections/sec1-p3';
import Sec2p3 from '../sections/sec2-p3';
import Sec3p3 from '../sections/sec3-p3';
import Sec4p3 from '../sections/sec4-p3';
import Sec5p3 from '../sections/sec5-p3';


const Bookingpage = () => {
      const [loading, setLoading] = useState(true);

      const [bookingData, setBookingData] = useState({
    ticket: null,
    quantity: 1,
    eventId: null, 
    user: {
      name: "",
     email: "",
      phone: "",

      job_title: "",
      company_name: "",
      address: ""
    },
    date: "",
  });


  const [errors, setErrors] = useState({});

    return ( <>
                     {loading && <Preloader onFinish={() => setLoading(false)} />}
            <main className='body-bg'>
                <Header />
                <Sec1booking   loading={loading}/>
                <Sec2p3 />
                <Sec3p3  bookingData={bookingData}
          setBookingData={setBookingData}
            errors={errors}
          setErrors={setErrors}/>
             <Sec4p3
                bookingData={bookingData}
                setBookingData={setBookingData}
                errors={errors}
              />
                <Sec5p3  bookingData={bookingData}
                  errors={errors}
                setErrors={setErrors}
                />

            </main>
            <Footerr />
    </> );
}
 
export default Bookingpage;